import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.arena_web.pages.AboutPage as _com_arena_web_pages_AboutPage
import com.arena_web.pages.ArenaPage as _com_arena_web_pages_ArenaPage
import com.arena_web.pages.ChatPage as _com_arena_web_pages_ChatPage
import com.arena_web.pages.ClientsPage as _com_arena_web_pages_ClientsPage
import com.arena_web.pages.DashboardPage as _com_arena_web_pages_DashboardPage
import com.arena_web.pages.FeedPage as _com_arena_web_pages_FeedPage
import com.arena_web.pages.HomePage as _com_arena_web_pages_HomePage
import com.arena_web.pages.KbTestPage as _com_arena_web_pages_KbTestPage
import com.arena_web.pages.NotFoundPage as _com_arena_web_pages_NotFoundPage
import com.arena_web.pages.PeoplePage as _com_arena_web_pages_PeoplePage
import com.arena_web.pages.PricingPage as _com_arena_web_pages_PricingPage
import com.arena_web.pages.PrivacyPage as _com_arena_web_pages_PrivacyPage
import com.arena_web.pages.ProfilePage as _com_arena_web_pages_ProfilePage
import com.arena_web.pages.RefundPage as _com_arena_web_pages_RefundPage
import com.arena_web.pages.SchedulePage as _com_arena_web_pages_SchedulePage
import com.arena_web.pages.SettingsPage as _com_arena_web_pages_SettingsPage
import com.arena_web.pages.TermsPage as _com_arena_web_pages_TermsPage
import com.arena_web.pages.chat.ChatRoomPage as _com_arena_web_pages_chat_ChatRoomPage
import com.arena_web.pages.clubs.ClubDetailPage as _com_arena_web_pages_clubs_ClubDetailPage
import com.arena_web.pages.events.EventDetailPage as _com_arena_web_pages_events_EventDetailPage
import com.arena_web.pages.profile.UserProfilePage as _com_arena_web_pages_profile_UserProfilePage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Arena"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_arena_web_pages_HomePage()
        }
        ctx.router.register(
            "/404",
        ) { pageCtx -> 
            _com_arena_web_pages_NotFoundPage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _com_arena_web_pages_AboutPage()
        }
        ctx.router.register(
            "/arena",
        ) { pageCtx -> 
            _com_arena_web_pages_ArenaPage()
        }
        ctx.router.register(
            "/chat",
        ) { pageCtx -> 
            _com_arena_web_pages_ChatPage()
        }
        ctx.router.register(
            "/chat/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_chat_ChatRoomPage()
        }
        ctx.router.register(
            "/clients",
        ) { pageCtx -> 
            _com_arena_web_pages_ClientsPage()
        }
        ctx.router.register(
            "/clubs/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_clubs_ClubDetailPage()
        }
        ctx.router.register(
            "/dashboard",
        ) { pageCtx -> 
            _com_arena_web_pages_DashboardPage()
        }
        ctx.router.register(
            "/events/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_events_EventDetailPage()
        }
        ctx.router.register(
            "/feed",
        ) { pageCtx -> 
            _com_arena_web_pages_FeedPage()
        }
        ctx.router.register(
            "/kbtest",
        ) { pageCtx -> 
            _com_arena_web_pages_KbTestPage()
        }
        ctx.router.register(
            "/people",
        ) { pageCtx -> 
            _com_arena_web_pages_PeoplePage()
        }
        ctx.router.register(
            "/pricing",
        ) { pageCtx -> 
            _com_arena_web_pages_PricingPage()
        }
        ctx.router.register(
            "/privacy",
        ) { pageCtx -> 
            _com_arena_web_pages_PrivacyPage()
        }
        ctx.router.register(
            "/profile",
        ) { pageCtx -> 
            _com_arena_web_pages_ProfilePage()
        }
        ctx.router.register(
            "/profile/{id}",
        ) { pageCtx -> 
            _com_arena_web_pages_profile_UserProfilePage()
        }
        ctx.router.register(
            "/refund",
        ) { pageCtx -> 
            _com_arena_web_pages_RefundPage()
        }
        ctx.router.register(
            "/schedule",
        ) { pageCtx -> 
            _com_arena_web_pages_SchedulePage()
        }
        ctx.router.register(
            "/settings",
        ) { pageCtx -> 
            _com_arena_web_pages_SettingsPage()
        }
        ctx.router.register(
            "/terms",
        ) { pageCtx -> 
            _com_arena_web_pages_TermsPage()
        }

        com.arena_web.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("nav-header", com.arena_web.ui.sections.header.NavHeaderStyle)
        ctx.theme.registerStyle("nav-link", com.arena_web.ui.sections.header.NavLinkStyle)
        ctx.theme.registerStyle("icon-button", com.arena_web.ui.sections.header.IconButtonStyle)
        ctx.theme.registerStyle("hidden-scrollbar", com.arena_web.ui.components.widgets.HiddenScrollbarStyle)
        ctx.theme.registerStyle("back-to-top-button", com.arena_web.ui.components.widgets.BackToTopButtonStyle)
        ctx.theme.registerStyle("arrow", com.arena_web.ui.components.widgets.ArrowStyle)
        ctx.theme.registerKeyframes("hero-chunk", com.arena_web.ui.sections.home.HeroChunkKeyframes)
        ctx.theme.registerKeyframes("hero-word-swap", com.arena_web.ui.sections.home.HeroWordSwapKeyframes)
        ctx.theme.registerKeyframes("hero-logo-intro", com.arena_web.ui.sections.home.HeroLogoIntroKeyframes)
        ctx.theme.registerKeyframes("hero-burst", com.arena_web.ui.sections.home.HeroBurstKeyframes)
        ctx.theme.registerKeyframes("side-menu-slide-in", com.arena_web.ui.sections.header.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("brand-glyph-dock", com.arena_web.ui.sections.header.components.BrandGlyphDockKeyframes)
        ctx.theme.registerKeyframes("brand-wordmark-reveal", com.arena_web.ui.sections.header.components.BrandWordmarkRevealKeyframes)
        ctx.theme.registerKeyframes("info-rise", com.arena_web.ui.sections.info.InfoRiseKeyframes)
        ctx.theme.registerKeyframes("snackbar-slide-down", com.arena_web.ui.components.notifications.SnackbarSlideDownKeyframes)
        ctx.theme.registerKeyframes("snackbar-slide-up", com.arena_web.ui.components.notifications.SnackbarSlideUpKeyframes)
        ctx.theme.registerKeyframes("toast-slide-in", com.arena_web.ui.components.notifications.ToastSlideInKeyframes)
        ctx.theme.registerKeyframes("modal-fade-in", com.arena_web.ui.components.overlay.ModalFadeInKeyframes)
        ctx.theme.registerKeyframes("modal-overlay-fade-in", com.arena_web.ui.components.overlay.ModalOverlayFadeInKeyframes)
        ctx.theme.registerKeyframes("expand-scale-in", com.arena_web.ui.components.overlay.ExpandScaleIn)
        ctx.theme.registerKeyframes("fade-in", com.arena_web.ui.components.widgets.FadeInKeyframes)
        ctx.theme.registerKeyframes("cookie-slide-up", com.arena_web.ui.components.widgets.CookieSlideUpKeyframes)
        ctx.theme.registerKeyframes("shimmer", com.arena_web.ui.components.widgets.ShimmerKeyframes)
        ctx.theme.registerKeyframes("popup-overlay-fade-in", com.arena_web.ui.components.events.PopupOverlayFadeIn)
        ctx.theme.registerKeyframes("popup-slide-up", com.arena_web.ui.components.events.PopupSlideUp)
        com.arena_web.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.arena_web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
